/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `hsa_step_data` message.
 *
 * User's current daily step data used for HSA custom data logging
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class HsaStepDataMesg : Mesg {
    public constructor() : super("HsaStepData", Profile.MesgNum.HSA_STEP_DATA)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** processing_interval, in s. Processing interval length in seconds. File start: 0xFFFFFFEF File stop: 0xFFFFFFEE */
    public var processingInterval: UShort?
        get() = getFieldValue(PROCESSING_INTERVAL_FIELD_NUM) as? UShort
        set(value) = setFieldValue(PROCESSING_INTERVAL_FIELD_NUM, value)

    /** Number of values stored in steps. */
    public val numSteps: Int
        get() = getField(STEPS_FIELD_NUM)?.numValues ?: 0

    /** steps, in steps. Total step sum */
    public var steps: List<UInt?>?
        get() {
            val field = getField(STEPS_FIELD_NUM) ?: return null
            return List(field.numValues) { getSteps(it) }
        }
        set(value) {
            removeField(STEPS_FIELD_NUM)
            value?.forEachIndexed { index, element -> setSteps(index, element) }
        }

    public fun getSteps(index: Int): UInt? =
        getFieldValue(STEPS_FIELD_NUM, index) as? UInt

    public fun setSteps(index: Int, value: UInt?) {
        setFieldValue(STEPS_FIELD_NUM, value, index)
    }

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val PROCESSING_INTERVAL_FIELD_NUM: UByte = 0u
        public const val STEPS_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("ProcessingInterval", 0u, BaseType.UINT16, 1.0, 0.0, "s", false)
            fields[1] = Field("Steps", 1u, BaseType.UINT32, 1.0, 0.0, "steps", false)
            return fields
        }
    }
}
